import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { environment: String, satismeterKey: String, user: Object }
  }

  connect() {
    if (this.environmentValue === "test" || this.satismeterKeyValue === "" || Object.keys(this.userValue).length === 0) {
      return
    }

    window.satismeter = window.satismeter || function() {
      (window.satismeter.q = window.satismeter.q || []).push(arguments)
    }

    window.satismeter.l = 1 * new Date()

    var script = document.createElement("script")
    var parent = document.getElementsByTagName("script")[0].parentNode

    script.async = 1
    script.src = "https://app.satismeter.com/js"
    parent.appendChild(script)

    let traits = {
      name: this.userValue.name,
      email: this.userValue.email,
      createdAt: this.userValue.created_at,
      plan: this.userValue.plan
    }

    if (this.userValue.hasOwnProperty("email_accounts_count")) {
      traits.emailAccountsCount = this.userValue.email_accounts_count
    }

    if (this.userValue.hasOwnProperty("first_signal_created_at")) {
      traits.firstSignalCreatedAt = this.userValue.first_signal_created_at
    }

    if (this.userValue.hasOwnProperty("active_signals_count")) {
      traits.activeSignalsCount = this.userValue.active_signals_count
    }

    satismeter({ writeKey: this.satismeterKeyValue, userId: this.userValue.id, language: i18n.locale, traits: traits })
  }
}
